import Cookies from 'js-cookie';
import { Item } from './types';
import { GA4_EVENT_NAMES } from './ga4/constants';

const { SELECT_ITEM_COOKIE } = GA4_EVENT_NAMES;

interface SelectItem {
  eventName: string;
  products: Item[] | null;
  itemListName: string;
}

const setSelectItemCookie = (item: SelectItem) => {
  Cookies.set(SELECT_ITEM_COOKIE, JSON.stringify(item));
  return;
};

export default setSelectItemCookie;
